<div class="bg-th-blue mt-0 container-fluid py-2">

    <div class=" d-flex justify-content-between align-content-center">

        <i class="fa fa-arrow-left text-white my-auto pointer" (click)="goBack()"></i>

        <a class="text-white f18 my-auto dirI">ثبت سریع</a>

    </div>

</div>


<!--------------------------------------------------------------------------------------------------------->

<section dir="rtl" class="d-flex justify-content-center align-items-center" style="height: 95.6vh;overflow: auto;">

    <div [formGroup]="sabtModelGps" class="row gx-2 gy-2 gy-md-0 mx-auto">

        <div class="col-12 mx-auto p-2">

            <div class="col-12 col-md-6 mx-auto d-flex p-2">

                <div class="col-8 col-md-9">

                    <input type="number" placeholder="شناسه دستگاه" 

                    [ngClass]="this.sabtModelGps.get('strUnitId')?.value == '' ? 'text-start' : 'text-end' "
                    
                    class="form-control text-start bg-light" 
                    
                    id="Imei" formControlName="strUnitId" [readonly]="imeIInp">
        
                </div>

                <div class="col-4 col-md-3 text-end">

                    <button class="btn btn-primary" (click)="Imei()">بررسی شناسه </button>
        
                </div>

            </div>

        </div>

        <div class="col-12 mx-auto p-2">

            <div class="col-12 col-md-6 mx-auto p-2">

                <div class="w-100">

                    <select class="form-select" formControlName="iGPS"> 
            
                    <option value="-1" > نوع gps </option>
            
                    <option *ngFor="let item of gpsType" value="{{item.iGPS}}">
            
                      {{item.strComment}}
            
                    </option>
            
                  </select>
            
                </div>

            </div>

        </div>

        <div class="col-12 mx-auto p-2">

            <div class="col-12 col-md-6 mx-auto p-2">

                <div class="w-100">

                    <input type="text" placeholder="شماره سیم کارت دستگاه" 

                    [ngClass]="this.sabtModelGps.get('strCellNo')?.value == '' ? 'text-start' : 'text-end' "
                    
                    class="form-control text-start bg-light" formControlName="strCellNo">
            
                </div>

            </div>

        </div>

        <div class="col-12 mx-auto p-2">

            <div class="col-12 col-md-6 mx-auto p-2">

                <div class="w-100">

                    <input type="text" placeholder="نام کاربری" 

                    [ngClass]="this.sabtModelGps.get('strUserName')?.value == '' ? 'text-start' : 'text-end' "
                    
                    class="form-control text-start bg-light" formControlName="strUserName">
            
                </div>

            </div>

        </div>

        <div class="col-12 mx-auto p-2">

            <div class="col-12 col-md-6 mx-auto p-2">

                <div class="w-100">

                    <input type="text" placeholder="رمز عبور" 

                    [ngClass]="this.sabtModelGps.get('strPassword')?.value == '' ? 'text-start' : 'text-end' "
                    
                    class="form-control text-start bg-light" formControlName="strPassword">
            
                </div>


            </div>

        </div>

        <div class="col-12 mx-auto p-2">

            <div class="col-12 col-md-6 mx-auto p-2">

                <div class="w-100">

                    <input type="text" placeholder="تکرار رمز عبور" 

                    [ngClass]="this.sabtModelGps.get('strRepeatPassword')?.value == '' ? 'text-start' : 'text-end' "
                    
                    class="form-control text-start bg-light" formControlName="strRepeatPassword">
            
                </div>


            </div>

        </div>

        <div class="col-12 mx-auto p-2">

            <div class="col-12 col-md-6 mx-auto p-2">

                <div class="w-100">

                    <button class="btn btn-success w-100" (click)="sabtGps()" [disabled]="isLoading">ثبت </button>
                
                </div>

            </div>

        </div>
    
    </div>

</section>

